import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ObjectExistsGuard} from './object-exists/object-exists.guard.service';
import {Page400Component} from './http-status/page400/page400.component';
import {Page404Component} from './http-status/page404/page404.component';
import {Page401Component} from './http-status/page401/page401.component';
import {ApplicationPipesModule} from '../application-pipes-module/application-pipes.module';

@NgModule({
  imports: [
    CommonModule,
    ApplicationPipesModule
  ],
  declarations: [
    Page400Component,
    Page404Component,
    Page401Component
  ],
  providers: [ObjectExistsGuard]
})
export class GuardModule {
}
